import React, { useEffect, useRef } from 'react';
import useDataFetch from '../../../../../../hooks/useDataFetch';
import { PropTypes } from 'prop-types';
import storePropTypes from '../../../../../../redux/store/propTypes';

function SingleDataFetcher({ url, httpHeader, cancelToken, onResult, onRequestCompleted, method, body }) {
   const { successful, isLoading, errorMessage, data, httpStatus } = useDataFetch(url, {
      header: httpHeader,
      cancelToken,
      onRequestCompleted,
      method,
      body,
   });
   // Held in a ref because the parent re-creates it every render, and called from an effect because it sets parent state.
   const onResultRef = useRef(onResult);
   onResultRef.current = onResult;

   useEffect(() => {
      onResultRef.current({ successful, isLoading, errorMessage, data, httpStatus });
   }, [successful, isLoading, errorMessage, data, httpStatus]);

   return <></>;
}

SingleDataFetcher.propTypes = {
   url: PropTypes.string,
   httpHeader: PropTypes.object,
   cancelToken: storePropTypes.cancelToken,
   onResult: PropTypes.func,
   onRequestCompleted: PropTypes.func,
   method: PropTypes.string,
   body: PropTypes.object,
};

export default SingleDataFetcher;
